var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddNewAccount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.268,
    height: 23.335,
    viewBox: "0 0 26.268 28.335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3850",
    "data-name": "Group 3850",
    transform: "translate(-25 -466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2335",
    "data-name": "Path 2335",
    d: "M24.43,0H1.838A1.914,1.914,0,0,0,0,1.983v24.37a1.914,1.914,0,0,0,1.838,1.983H13.21c.444,0,.8-.679.8-1.123v-.02c0-.444-.36-1.017-.8-1.017H3.872a1.914,1.914,0,0,1-1.838-1.983V4.143A1.914,1.914,0,0,1,3.872,2.16h3.94V7.878A1.455,1.455,0,0,0,9.266,9.334l3.867-1.7,3.906,1.7a1.455,1.455,0,0,0,1.455-1.455V2.16h3.9a1.915,1.915,0,0,1,1.838,1.983V12.9c0,.444.573.8,1.017.8s1.017-.36,1.017-.8V1.983A1.914,1.914,0,0,0,24.43,0M17,7.78l-3.867-1.7L9.3,7.78V2.16H17Z",
    transform: "translate(25 466)",
    fill: "#343433"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2336",
    "data-name": "Path 2336",
    d: "M144.736,132.489a4.1,4.1,0,1,0-5.917.019,4.08,4.08,0,0,0-2.914,3.909V137.7a.924.924,0,0,0,.924.924h.149a.924.924,0,0,0,.924-.924v-1.145a2.855,2.855,0,0,1,2.855-2.855h.321a4.066,4.066,0,0,0,1.381,0h.555a2.855,2.855,0,0,1,2.855,2.855V137.7a.924.924,0,0,0,1.848,0v-1.285a4.08,4.08,0,0,0-2.981-3.928m-2.968-.682a2.146,2.146,0,1,1,2.146-2.146,2.146,2.146,0,0,1-2.146,2.146",
    transform: "translate(-96.449 353.794)",
    fill: "#343433"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3849",
    "data-name": "Group 3849"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2333",
    "data-name": "Path 2333",
    d: "M49.216,161.286H42.483a1.083,1.083,0,0,1,0-2.166h6.733a1.083,1.083,0,0,1,0,2.166",
    transform: "translate(-12.828 325.603)",
    fill: "#343433"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2337",
    "data-name": "Path 2337",
    d: "M7.817,2.166H1.083A1.083,1.083,0,1,1,1.083,0H7.817a1.083,1.083,0,1,1,0,2.166",
    transform: "translate(34.105 481.355) rotate(90)",
    fill: "#343433"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNewAccount);
export default __webpack_public_path__ + "static/media/add_new_account.e36c2c1ce2917e57115525b60d2a2059.svg";
export { ForwardRef as ReactComponent };